import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initCapacitor } from "@/native/capacitor";
import { registerServiceWorker } from "@/lib/registerSW";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Native bootstrap (no-op in browser).
const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
initCapacitor(API_BASE);

// PWA: register the service worker (production only).
registerServiceWorker();
